import React from "react";

import { healthStateToTextColorToken } from "../../../../../../common/functions";
import type { MonitorCheckStatus } from "../../../../../../common/openapi";
import { FormatViewTime } from "../../../../../../components/react/viewtime/FormatViewTime";
import { ViewTimeLink } from "../../../../../../components/react/viewtimelink/ViewTimeLink";

interface PinnedMonitorInfoProps {
	monitorStatus: MonitorCheckStatus;
}

export const MonitorStatusInfo: React.FC<PinnedMonitorInfoProps> = ({ monitorStatus }) => (
	<div className="font-normal text-13 text-grey-700 leading-5" data-testid="monitor-status-info">
		Monitor status for <FormatViewTime className="font-medium" time={monitorStatus.topologyTime} />
		:<br />
		<span
			className="font-medium"
			data-testid="health-state-label"
			style={{ color: `var(${healthStateToTextColorToken(monitorStatus.health)})` }}
		>
			{monitorStatus.health}
		</span>{" "}
		health state triggered <ViewTimeLink className="text-grey-700" time={monitorStatus.triggeredTimestamp} />
	</div>
);
